import {
  type RouteObject,
} from "react-router";
import VenueListApp from "venue/list/app";

declare let viewModel: any;

export const venueRoute: RouteObject = {
  path: "venue",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: VenueListApp,
  }]
};